export const parseQuery = (queryString: string) => {
  const params = new URLSearchParams(queryString);
  const query: Record<string, string> = {};

  params.forEach((value, key) => {
    query[key] = value;
  });
  return query;
};

// This simple slugify method is not intended to deal with many special characters, since it's usage is very limited.
// If, at some point, we need a more rigorous slugify, we can install the JS package slugify and use it instead.
export const slugify = (string: string) => string
  .toString()
  .trim()
  .toLowerCase()
  .replace(/\s+/g, '-')
  .replace(/[^\w-]+/g, '')
  .replace(/_+/g, '-')
  .replace(/--+/g, '-')
  .replace(/^-+/, '')
  .replace(/-+$/, '');
